import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../Component/Header';
import BrandCustomizationSection from './BrandCustomizationSection';
import DoorsApplicationAreaMapping from './DoorsApplicationAreaMapping';
import ProjectHeader from '../Component/ProjectHeader';

function DoorsCustomize() {
  const navigate = useNavigate();
  const location = useLocation();
  const { data, type } = location.state || {};
  
  const [loading, setLoading] = useState(true);
  const [projectData, setProjectData] = useState(data || {});
  const [doorSubcategories, setDoorSubcategories] = useState([]);
  const [preEngDoorSubcategories, setPreEngDoorSubcategories] = useState([]);
  const [doorProducts, setDoorProducts] = useState({});
  const [preEngDoorProducts, setPreEngDoorProducts] = useState({});
  const [applicationAreas, setApplicationAreas] = useState([]);
  const [doorCores, setDoorCores] = useState([]);
  const [quotationData, setQuotationData] = useState(null);
  
  useEffect(() => {
    if (data && data._id) {
  // console.log("Initial data:", data);
      
      // Extract application areas from data
      if (data.items && Array.isArray(data.items)) {
        const areas = data.items
          .filter(item => item.application_areas)
          .map(item => ({
            ...item.application_areas,
            applied_areas: item.applied_areas || [],
            item: item
          }))
          .filter((area, index, self) =>
            index === self.findIndex(a =>
              a._id === area._id
            )
          );
        
      //  console.log("Extracted application areas:", areas);
        setApplicationAreas(areas);
      }
      
      // Fetch door quotation data with vendors and subcategories
      getDoorQuotationDataWithVendorsAndProductSubcategories();
      fetchDoorProducts();
    } else {
      // Handle case when data is not available
      console.error("No data provided for customization");
      setLoading(false);
    }
  }, [data]);
  
  const getDoorQuotationDataWithVendorsAndProductSubcategories = async () => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem('token');
      
      if (!token) {
        console.error("Authentication token not found");
        return;
      }
      
      if (!data || !data._id) {
        console.error("Quotation ID not available");
        return;
      }
      
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/get-door-quotation-data-with-vendors-and-product-subcategories?quotation_id=${data._id}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token,
          },
        }
      );
      
      const result = await response.json();
     // console.log("Door quotation data:", result);
      
      if (result.success) {
        // Set quotation data
        setQuotationData(result.data.quotation);
        //console.log('result.data.regularDoorSubcategories:', result.data.regularDoorSubcategories);
        // Set door subcategories
        setDoorSubcategories(result.data.regularDoorSubcategories || []);
        setPreEngDoorSubcategories(result.data.preEngDoorSubcategories || []);
        
        // Set door cores
        setDoorCores(result.data.doorCores || []);
        
        // Update application areas if available in the response
        if (result.data.applicationAreas && result.data.applicationAreas.length > 0) {
          setApplicationAreas(result.data.applicationAreas);
        }
        
        // Fetch products for each subcategory
        if (result.data.regularDoorSubcategories) {
          result.data.regularDoorSubcategories.forEach(subcat => {
          });
        }
        
        if (result.data.preEngDoorSubcategories) {
          result.data.preEngDoorSubcategories.forEach(subcat => {
          });
        }
      } else {
        console.error("Failed to fetch door quotation data:", result.message);
        // Fallback to the old method if the new endpoint fails
        fetchDoorSubcategoriesAndTheirVendors();
      }
    } catch (error) {
      console.error("Error fetching door quotation data:", error);
      // Fallback to the old method if the new endpoint fails
      fetchDoorSubcategoriesAndTheirVendors();
    } finally {
      setLoading(false);
    }
  };
  
  const fetchDoorSubcategoriesAndTheirVendors = async () => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem('token');
      
      if (!token) {
        console.error("Authentication token not found");
        return;
      }
      
      if (!data || !data.product_category_id || !data.product_category_id._id) {
        console.error("Product category ID not available");
        return;
      }
      
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/get-door-vendor-by-subcategory?product_category_id=${data.product_category_id._id}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token,
          },
        }
      );
      
      const result = await response.json();
     // console.log("Door subcategories:", result);
      
      if (result.success) {
        // Separate regular doors and pre-engineered doors
        const regularDoors = result.data.filter(subcat =>
          !subcat.subcategory_name.toLowerCase().includes('pre eng doors')
        );
       // console.log('regularDoors', regularDoors);
        
        const preEngDoors = result.data.filter(subcat =>
          subcat.subcategory_name.toLowerCase().includes('pre eng doors')
        );
        
        setDoorSubcategories(regularDoors);
        setPreEngDoorSubcategories(preEngDoors);
        
        // Fetch products for each subcategory
        regularDoors.forEach(subcat => {
         // fetchDoorProducts(subcat._id, 'regular');
        });
        
        preEngDoors.forEach(subcat => {
         // fetchDoorProducts(subcat._id, 'preEng');
        });
      } else {
        console.error("Failed to fetch door subcategories:", result.message);
      }
    } catch (error) {
      console.error("Error fetching door subcategories:", error);
    } finally {
      setLoading(false);
    }
  };
  
  const fetchDoorProducts = async () => {
    try {
      const token = sessionStorage.getItem('token');
      
      if (!token ) {
        console.error("Token or subcategory ID not available");
        return;
      }
      
      // The endpoint should be using POST method based on the backend implementation
      // Also, the data should be sent in the request body, not as a query parameter
      const response = await fetch(
        `${process.env.REACT_APP_FORE_BRICKBUCKET}product-groups/get-product-groups-and-addon-products?product_category_id=${data.product_category_id._id}`,
        {
          method: 'GET', // Changed from GET to POST
          headers: {
            'Content-Type': 'application/json',
            'x-token': token,
          },
        }
      );
     // console.log("Response:", response);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const result = await response.json();
      //console.log(`Products for  door subcategory :`, result);
      
      if (result.success) {
        // Make sure we're accessing the correct data structure based on the API response
        const productData = result.data || {};
        
       console.log("Product Data:", productData);
          // Store only doors product groups data
          setDoorProducts(productData.onlyDoorsProductGroups || []);
        
          setPreEngDoorProducts( productData.preEngDoorsProductGroups || [])
       
      } else {
        console.error(`Failed to fetch  door products:`, result.message);
      }
    } catch (error) {
      console.error(`Error fetching  door products:`, error);
      // Consider adding error state handling here
    }
  };
  
  
const handleProductSelection = async (areaName, productId) => {
  try {
    // Validate inputs
    if (!areaName || !productId) {
      console.error("Invalid inputs: areaName and productId are required");
      return;
    }

    // Create a deep copy of the quotation data to avoid mutation issues
    const updatedQuotationData = JSON.parse(JSON.stringify(quotationData));
    
    // Ensure items array exists
    if (!updatedQuotationData.items || !Array.isArray(updatedQuotationData.items)) {
      updatedQuotationData.items = [];
    }

    // Find the item index for the given area name
    const findItemIndex = updatedQuotationData.items.findIndex(
      item => item?.application_areas?.area_name === areaName
    );

    // Find the selected product data from either doorProducts or preEngDoorProducts
    const onlyDoorProductData = Array.isArray(doorProducts) ? 
      doorProducts.find(product => product?._id === productId) : null;
      
    const preEngDoorProductData = Array.isArray(preEngDoorProducts) ? 
      preEngDoorProducts.find(product => product?._id === productId) : null;

    // Get the selected product data (from either source)
    const selectedProductData = onlyDoorProductData || preEngDoorProductData;

    // Validate product data
    if (!selectedProductData) {
      console.error("Selected product not found in available products", {
        productId,
        doorProductsCount: doorProducts?.length || 0,
        preEngDoorProductsCount: preEngDoorProducts?.length || 0
      });
      return;
    }

    if (findItemIndex !== -1) {
      // Update existing item
      const currentItem = updatedQuotationData.items[findItemIndex] || {};
      
      // Update the item with the selected product details
      updatedQuotationData.items[findItemIndex] = {
        ...currentItem,
        item_name: selectedProductData.product_group_name || selectedProductData.product_name || "Unnamed Product",
        item_id: selectedProductData._id,
        item_group_id: selectedProductData._id || 
                      (selectedProductData.product_group_id && typeof selectedProductData.product_group_id === 'object' ? 
                       selectedProductData.product_group_id._id : selectedProductData.product_group_id),
        item_group_name: selectedProductData.product_group_name || selectedProductData.product_name,
        selling_price: parseFloat(selectedProductData.selling_price || 0),
        cost_price: parseFloat(selectedProductData.cost_price || 0),
        vendor_id: selectedProductData.vendor_id,
        vendor_name: selectedProductData.vendor_name,
        product_category_id: selectedProductData.product_category_id,
        product_category_name: selectedProductData.product_category_name,
        product_sub_category_id: selectedProductData.product_sub_category_id,
        item_group_quantity: selectedProductData?.product_group_quantity,
        item_group_unit: selectedProductData?.product_group_unit,
        item_group_description: selectedProductData.product_group_description || "",
        item_group_image: selectedProductData.product_group_image || "",
        item_group_type: selectedProductData.product_group_type || "",
        selected_product_id: productId,
        quantity: currentItem.quantity || 1, // Preserve existing quantity or default to 1
        tax_rate: selectedProductData.GST || currentItem.tax_rate || 0 ,// Use GST from product or preserve existing
        applied_areas: await handleApplicationAreas( currentItem.applied_areas || []),
      };

      // Handle addons
      try {
        // Preserve hardware addons
        const hardwareAddons = Array.isArray(updatedQuotationData.items[findItemIndex].product_addons) ?
          updatedQuotationData.items[findItemIndex].product_addons.filter(
            addon => addon?.product_addon_type?.toLowerCase() === 'hardware'
          ) : [];

        // Map new addons based on the selected product
        if (selectedProductData.addons && Array.isArray(selectedProductData.addons)) {
          // Process and map addons
          const mappedAddons = await mapProductAddons(
            selectedProductData.addons, 
            Array.isArray(doorSubcategories) ? doorSubcategories : []
          );
          
          // Extract products from addon groups
          const mappedAddonProducts = mappedAddons && mappedAddons.length > 0 
            ? mappedAddons.flatMap(addonType => 
                (addonType.addon_groups || []).flatMap(addonGroup => 
                  (addonGroup.products || []).map(product => ({
                    ...product,
                    product_addon_type: addonType.addon_type || "Add-on",
                    quantity: 1,
                    tax_rate: product.GST || 0
                  }))
                )
              )
            : [];
          
          // Combine mapped addons with hardware addons
          updatedQuotationData.items[findItemIndex].product_addons = [
            ...mappedAddonProducts,
            ...hardwareAddons
          ];
        } else {
          // If no addons in the product, keep only hardware addons
          console.log('No addons in the product, keeping only hardware addons');
          updatedQuotationData.items[findItemIndex].product_addons = hardwareAddons;
        }
      } catch (addonError) {
        console.error("Error processing addons:", addonError);
        // Keep existing addons in case of error
        if (!updatedQuotationData.items[findItemIndex].product_addons) {
          updatedQuotationData.items[findItemIndex].product_addons = [];
        }
      }
    } else {
      console.log('No item found for area:', areaName, '- Creating new item');
      // Create a new item if not found
      try {
        const newItem = {
          application_areas: {
            area_name: areaName,
            area: areaName,
            count: 1
          },
          item_name: selectedProductData.product_name || selectedProductData.product_group_name || "Unnamed Product",
          item_id: selectedProductData._id,
          item_group_id: selectedProductData.product_group_id && typeof selectedProductData.product_group_id === 'object' ? 
                        selectedProductData.product_group_id._id : 
                        (selectedProductData.product_group_id || selectedProductData._id),
          item_group_name: selectedProductData.product_group_name || selectedProductData.product_name,
          selling_price: parseFloat(selectedProductData.selling_price || 0),
          cost_price: parseFloat(selectedProductData.cost_price || 0),
          vendor_id: selectedProductData.vendor_id,
          vendor_name: selectedProductData.vendor_name,
          product_category_id: selectedProductData.product_category_id,
          product_category_name: selectedProductData.product_category_name,
          product_sub_category_id: selectedProductData.product_sub_category_id,
          item_group_quantity: selectedProductData.product_group_quantity,
          item_group_unit: selectedProductData.product_group_unit,
          item_group_description: selectedProductData.product_group_description || "",
          item_group_image: selectedProductData.product_group_image || "",
          item_group_type: selectedProductData.product_group_type || "",
          selected_product_id: productId,
          quantity: 1, // Default quantity
          tax_rate: selectedProductData.GST || 0 // Use GST from product
        };

        // Map addons for the new item
        if (selectedProductData.addons && Array.isArray(selectedProductData.addons)) {
          const mappedAddons = await mapProductAddons(
            selectedProductData.addons, 
            Array.isArray(doorSubcategories) ? doorSubcategories : []
          );
          
          // Extract products from addon groups
          const mappedAddonProducts = mappedAddons && mappedAddons.length > 0 
            ? mappedAddons.flatMap(addonType => 
                (addonType.addon_groups || []).flatMap(addonGroup => 
                  (addonGroup.products || []).map(product => ({
                    ...product,
                    product_addon_type: addonType.addon_type || "Add-on",
                    quantity: 1,
                    tax_rate: product.GST || 0
                  }))
                )
              )
            : [];
            
          newItem.product_addons = mappedAddonProducts;
        } else {
          newItem.product_addons = [];
        }
        
        console.log("New Item created:", newItem);
        updatedQuotationData.items.push(newItem);
      } catch (newItemError) {
        console.error("Error creating new item:", newItemError);
        return;
      }
    }

    // Calculate pricing
    let latestQuotationData;
    try {
      latestQuotationData = await calculateQuotationPricing(updatedQuotationData);
      console.log("Quotation pricing calculated successfully");
    } catch (pricingError) {
      console.error("Error calculating quotation pricing:", pricingError);
      latestQuotationData = updatedQuotationData; // Use uncalculated data as fallback
    }
console.log(updatedQuotationData.items)  
    // Update state with the new data
    setQuotationData(latestQuotationData);
    console.log("Product selection completed successfully");
    
  } catch (error) {
    console.error("Error in handleProductSelection:", error);
  }
};

const handleApplicationAreas = (applicationAreas) => {
  // Validate input
  if (!applicationAreas) {
    console.error("handleApplicationAreas: applicationAreas is null or undefined");
    return [];
  }
  
  if (!Array.isArray(applicationAreas)) {
    console.error(`handleApplicationAreas: Expected array, got ${typeof applicationAreas}`);
    return [];
  }
  
  const applicationAreasMaping = [];
  
  applicationAreas.forEach((area, index) => {
    // Skip invalid entries
    if (!area || typeof area !== 'object') {
      console.warn(`handleApplicationAreas: Invalid area at index ${index}, skipping`);
      return;
    }
    
    try {
      // Create a clean copy of the area object
      const cleanArea = { ...area };
      
      cleanArea.selected_design = null;
      
      // Add to mapping
      applicationAreasMaping.push(cleanArea);
    } catch (error) {
      console.error(`handleApplicationAreas: Error processing area at index ${index}:`, error);
      // Continue with next area
    }
  });
  
  return applicationAreasMaping;
};




    const handleVendorChange = async (subcategoryId, vendor , subcategory_name) => {
      console.log(subcategory_name)
    console.log("Selected Vendor:", vendor);
    console.log("Subcategory ID:", subcategoryId);
    
    try {
      setLoading(true);
      
      if (!vendor) {
        console.error("Vendor not available");
        return;
      }
      
      // PART 1: Update door subcategories with the selected vendor
      // Create a deep copy of the doorSubcategories array
      const updatedDoorSubcategories = JSON.parse(JSON.stringify(doorSubcategories));
      
      // Find the subcategory that matches the subcategoryId
      const subcategoryToUpdate = updatedDoorSubcategories.find(
        subcategory => subcategory.subcategory && subcategory.subcategory._id === subcategoryId
      );
      
      // If the subcategory is found, update it
      if (subcategoryToUpdate) {
        subcategoryToUpdate.defaultVendor = vendor;
        subcategoryToUpdate.vendors = [vendor];
        
        console.log("Updated Subcategory Data:", subcategoryToUpdate);
        
        // Update the state with the new array
        setDoorSubcategories(updatedDoorSubcategories);
      } else {
        console.warn(`Subcategory with ID ${subcategoryId} not found in doorSubcategories`);
      }
      
      // PART 2: Update quotation data with products from the selected vendor
      if (!quotationData) {
        console.error("Quotation data not available");
        setLoading(false);
        return;
      }
      
      // Create a copy of the quotation data to work with
       const updatedQuotationData = {...quotationData};
      
      // Process each item in the quotation
      for (let itemIndex = 0; itemIndex < updatedQuotationData.items.length; itemIndex++) {
        const item = updatedQuotationData.items[itemIndex]; 
        
        // Find the corresponding product in doorProducts or preEngDoorProducts
        let productData = null;
        
        // Check in regular door products
        if (doorProducts && Array.isArray(doorProducts)) {
          productData = doorProducts.find(product =>
            product._id === item.item_id || 
            product._id === item.item_group_id || 
            product._id === item.selected_product_id
          );
        }
        
        // If not found in regular doors, check in pre-engineered door products
        if (!productData && preEngDoorProducts && Array.isArray(preEngDoorProducts)) {
          productData = preEngDoorProducts.find(product =>
            product._id === item.item_id || 
            product._id === item.item_group_id || 
            product._id === item.selected_product_id
          );
        }
        
        if(subcategory_name === "Pre-Engineered Doors"){
          updatedQuotationData.items[itemIndex].vendor_id = vendor._id;

        } else {
  // If we found the product data
  if (productData) {
    console.log("Found Product Data for item:", item.item_name);
    
    // Get addons from the product data
    const productAddons = productData.addons || [];
    
    // Process each addon from the product data
    for (const addon of productAddons) {
      // Skip if addon doesn't have addon_groups
      if (!addon.addon_groups || !Array.isArray(addon.addon_groups)) {
        continue;
      }
      
      // Check if this addon has any groups matching our subcategory
      const hasMatchingGroup = addon.addon_groups.some(
        group => group.product_sub_category_id === subcategoryId
      );
      
      if (hasMatchingGroup) {
        // Get existing product addons or initialize empty array
        const existingProductAddons = item.product_addons || [];
        
        // Filter out addons with the matching subcategory ID
        const remainingAddons = existingProductAddons.filter(
          existingAddon => existingAddon.item_sub_category_id !== subcategoryId
        );
        
        // Collect all vendor products from matching addon groups
        const allVendorProducts = [];
        
        for (const addonGroup of addon.addon_groups) {
          if (addonGroup.product_sub_category_id === subcategoryId) {
            if (addonGroup.products && Array.isArray(addonGroup.products)) {
              const vendorProducts = addonGroup.products.filter(
                product => product.vendor_id === vendor._id
              );
              
              if (vendorProducts.length > 0) {
                allVendorProducts.push(...vendorProducts);
              }
            }
          }
        }
        
        // Map vendor products to the format needed for product_addons
        const newAddons = allVendorProducts.map(product => ({
          item_sub_category_id: product.product_sub_category_id,
          item_id: product._id,
          item_name: product.product_name || product.name || '',
          selling_price: parseFloat(product.selling_price) || 0,
          cost_price: parseFloat(product.cost_price) || 0,
          UOM_id: product.UOM_id,
          item_description: product.description || product.product_description || '',
          item_image: product.image || product.product_image || '',
          item_group_id: product.product_group_id,
          item_group_name: product.product_group_name || product.product_group || '',
          product_addon_type: addon.addon_type || 'door core',
          item_quantity: item.quantity || 1,
          vendor_id: product.vendor_id,
          vendor_name: vendor.name,
          item_sub_category_id: product.product_sub_category_id,
          item_sub_category_name: product.product_sub_category || '',
        }));
       // console.log("New Addons:", newAddons);
        
        // Combine remaining addons with new addons
        const finalAddons = [...remainingAddons, ...newAddons];
        
        // Update the item with the combined addons
        updatedQuotationData.items[itemIndex].product_addons = finalAddons;
        
        // Break out of the addon loop since we've processed this item
        break;
      }
    }
  }
}

        }
       const LatestQuotationData = await calculateQuotationPricing(updatedQuotationData)
     /*  // Calculate total price after updating addons
      updatedQuotationData.total = calculateTotalPrice(updatedQuotationData.items); */
      
      // Update state with the new data
      setQuotationData(LatestQuotationData);
      
    } catch (error) {
      console.error("Error changing addon vendor:", error);
    } finally {
      setLoading(false);
    }
  };
  
/*   const calculateQuotationPricing = (quotationData) => {
  if (!quotationData || !quotationData.items || !Array.isArray(quotationData.items)) {
    console.error("Invalid quotation data structure");
    return quotationData;
  }
  
  // Create a deep copy to avoid mutating the original data
  const updatedQuotation = JSON.parse(JSON.stringify(quotationData));
  
  // First, group items by item_group_id to calculate total quantities
  const itemsByGroupId = {};
  
  // Group items and calculate total quantities per group
  updatedQuotation.items.forEach(item => {
    if (!item) return;
    
    const groupId = item.item_group_id?.toString();
    if (!groupId) return;
    
    if (!itemsByGroupId[groupId]) {
      itemsByGroupId[groupId] = {
        items: [],
        totalQuantity: 0
      };
    }
    
    itemsByGroupId[groupId].items.push(item);
    itemsByGroupId[groupId].totalQuantity += parseFloat(item.quantity || 0);
  });
  
  // Process each group to find applicable MOQs
  for (const groupId in itemsByGroupId) {
    const group = itemsByGroupId[groupId];
    if (!group.items.length) continue;
    
    // Find product data for this group (using the first item as reference)
    const referenceItem = group.items[0];
    let productData = null;
    
    // Find product data from preEngDoorProducts or doorProducts
    productData = preEngDoorProducts.find(product => 
      product._id === referenceItem.item_id || 
      product._id === referenceItem.item_group_id || 
      product._id === referenceItem.selected_product_id
    );
    
    if (!productData) {
      productData = doorProducts.find(product => 
        product._id === referenceItem.item_id || 
        product._id === referenceItem.item_group_id || 
        product._id === referenceItem.selected_product_id
      );
    }
    
    if (!productData) {
      console.log('Product not found for group:', groupId);
      continue;
    }
    
    // Find applicable MOQ based on total group quantity
    let applicableMoq = null;
    
    if (productData.moq?.moqs && Array.isArray(productData.moq.moqs) && productData.moq.moqs.length > 0) {
      // Sort MOQs by min_quantity in descending order to find the most specific tier first
      const sortedMoqs = [...productData.moq.moqs].sort((a, b) => {
        const bMin = parseFloat(b.min_quantity) || 0;
        const aMin = parseFloat(a.min_quantity) || 0;
        return bMin - aMin;
      });
      
      // Find the first MOQ that applies to our total quantity
      for (const moq of sortedMoqs) {
        const minQty = parseFloat(moq.min_quantity) || 0;
        const maxQty = parseFloat(moq.max_quantity) || Infinity;
        
        if (group.totalQuantity >= minQty && group.totalQuantity <= maxQty) {
          applicableMoq = moq;
          break;
        }
      }
    }
    
    // Store the applicable MOQ with the group for later use
    group.applicableMoq = applicableMoq;
    group.productData = productData;
  }
  
  // Track total amounts for the entire quotation
  let quotationSubtotal = 0;
  let quotationTaxTotal = 0;
  let quotationGrandTotal = 0;
  
  // Process each item in the quotation
  updatedQuotation.items = updatedQuotation.items.map(item => {
    if (!item) return item;
    
    // Get base quantity
    const quantity = parseFloat(item.quantity || 0);
    const groupId = item.item_group_id?.toString();
    
    // Get base selling and cost prices
    let baseSellingPrice = 0;
    let baseCostPrice = 0;
    
    // If this item belongs to a group with an applicable MOQ, use the MOQ pricing
    if (groupId && itemsByGroupId[groupId]) {
      const group = itemsByGroupId[groupId];
      
      if (group.applicableMoq) {
        // Use MOQ pricing
        baseSellingPrice = parseFloat(group.applicableMoq.selling_price || 0);
        baseCostPrice = parseFloat(group.applicableMoq.cost_price || 0);
        
        console.log(`Applied MOQ pricing to item in group ${groupId}:`, {
          itemId: item.item_id,
          originalPrice: item.selling_price,
          moqPrice: baseSellingPrice,
          totalGroupQuantity: group.totalQuantity,
          moqMinQty: group.applicableMoq.min_quantity,
          moqMaxQty: group.applicableMoq.max_quantity
        });
      } else if (group.productData) {
        // No applicable MOQ, use product base price
        baseSellingPrice = parseFloat(group.productData.selling_price || item.selling_price || 0);
        baseCostPrice = parseFloat(group.productData.cost_price || item.cost_price || 0);
      } else {
        // Fallback to item's own price
        baseSellingPrice = parseFloat(item.selling_price || 0);
        baseCostPrice = parseFloat(item.cost_price || 0);
      }
    } else {
      // Item doesn't belong to a group, use its own price
      baseSellingPrice = parseFloat(item.selling_price || 0);
      baseCostPrice = parseFloat(item.cost_price || 0);
    }
    
    // Store original base price before addon calculations
    item.base_selling_price = baseSellingPrice;
    
    // Initialize addon totals
    let addonSellingPriceTotal = 0;
    let addonCostPriceTotal = 0;
    let addonTaxTotal = 0;
    
    // Process addons if they exist
    if (item.product_addons && Array.isArray(item.product_addons)) {
      item.product_addons = item.product_addons.map(addon => {
        if (!addon) return addon;
        
        // Get addon quantity (default to main item quantity if not specified)
        const addonQuantity = parseFloat(addon.quantity || quantity);
        
        // Get addon selling price - NO MOQ PROCESSING FOR ADDONS
        const addonSellingPrice = parseFloat(addon.selling_price || 0);
        const addonCostPrice = parseFloat(addon.cost_price || 0);
        
        // Calculate tax for the addon
        const addonTaxRate = parseFloat(addon.tax_rate || 0);
        const addonTax = (addonSellingPrice * addonTaxRate) / 100;
        
        // Update addon with calculated values
        addon.calculated_selling_price = addonSellingPrice;
        addon.calculated_cost_price = addonCostPrice;
        addon.calculated_tax = addonTax;
        addon.total = addonSellingPrice * addonQuantity;
        addon.tax_total = addonTax * addonQuantity;
        
        // Add to addon totals - exclude hardware addons from the main item price
        if (addon?.product_addon_type?.toLowerCase() !== 'hardware') {
          addonSellingPriceTotal += addon.total;
          addonCostPriceTotal += addonCostPrice * addonQuantity;
          addonTaxTotal += addon.tax_total;
        }
        
        return addon;
      });
    }
    
    // Calculate tax rate and amount for the main item
    const taxRate = parseFloat(item.tax_rate || 0);
    
    // Calculate per-unit values
    const addonPricePerUnit = quantity > 0 ? addonSellingPriceTotal / quantity : 0;
    const totalSellingPricePerUnit = baseSellingPrice + addonPricePerUnit;
    
    // Calculate tax on the combined price (base + addons)
    const itemTaxPerUnit = (totalSellingPricePerUnit * taxRate) / 100;
    
    // Calculate totals for this item including addons
    const itemSubtotal = totalSellingPricePerUnit * quantity;
    const itemTaxTotal = itemTaxPerUnit * quantity;
    const itemTotal = itemSubtotal + itemTaxTotal;
    
    // Update item with calculated values
    item.calculated_selling_price = totalSellingPricePerUnit;
    item.selling_price = totalSellingPricePerUnit; // Update selling price to include addons
    item.calculated_cost_price = baseCostPrice;
    item.calculated_tax = itemTaxPerUnit;
    item.subtotal = itemSubtotal;
    item.tax_total = itemTaxTotal;
    item.total = itemTotal;
    item.addon_total = addonSellingPriceTotal;
    item.addon_price_per_unit = addonPricePerUnit;
    
    // Add to quotation totals
    quotationSubtotal += itemSubtotal;
    quotationTaxTotal += itemTaxTotal;
    quotationGrandTotal += itemTotal;
    
    return item;
  });
  
  // Update quotation with calculated totals
  updatedQuotation.subtotal = quotationSubtotal;
  updatedQuotation.tax_total = quotationTaxTotal;
  updatedQuotation.total = quotationGrandTotal;
  
  return updatedQuotation;
}; */

const calculateQuotationPricing = (quotationData) => {
  if (!quotationData || !quotationData.items || !Array.isArray(quotationData.items)) {
    console.error("Invalid quotation data structure");
    return quotationData;
  }
  
  // Create a deep copy to avoid mutating the original data
  const updatedQuotation = JSON.parse(JSON.stringify(quotationData));
  
  // First, group items by item_group_id to calculate total quantities
  const itemsByGroupId = {};
  
  // Group items and calculate total quantities per group
  updatedQuotation.items.forEach(item => {
    if (!item) return;
    
    const groupId = item.item_group_id?.toString();
    if (!groupId) return;
    
    if (!itemsByGroupId[groupId]) {
      itemsByGroupId[groupId] = {
        items: [],
        totalQuantity: 0
      };
    }
    
    itemsByGroupId[groupId].items.push(item);
    itemsByGroupId[groupId].totalQuantity += parseFloat(item.quantity || 0);
  });
  
  // Process each group to find applicable MOQs
  for (const groupId in itemsByGroupId) {
    const group = itemsByGroupId[groupId];
    if (!group.items.length) continue;
    
    // Find product data for this group (using the first item as reference)
    const referenceItem = group.items[0];
    let productData = null;
    
    // Find product data from preEngDoorProducts or doorProducts
    productData = preEngDoorProducts.find(product =>
      product._id === referenceItem.item_id ||
      product._id === referenceItem.item_group_id ||
      product._id === referenceItem.selected_product_id
    );
    
    if (!productData) {
      productData = doorProducts.find(product =>
        product._id === referenceItem.item_id ||
        product._id === referenceItem.item_group_id ||
        product._id === referenceItem.selected_product_id
      );
    }
    
    if (!productData) {
      console.log('Product not found for group:', groupId);
      continue;
    }
    
    // Find applicable MOQ based on total group quantity
    let applicableMoq = null;
    
    if (productData.moq?.moqs && Array.isArray(productData.moq.moqs) && productData.moq.moqs.length > 0) {
      // Sort MOQs by min_quantity in descending order to find the most specific tier first
      const sortedMoqs = [...productData.moq.moqs].sort((a, b) => {
        const bMin = parseFloat(b.min_quantity) || 0;
        const aMin = parseFloat(a.min_quantity) || 0;
        return bMin - aMin;
      });
      
      // Find the first MOQ that applies to our total quantity
      for (const moq of sortedMoqs) {
        const minQty = parseFloat(moq.min_quantity) || 0;
        const maxQty = parseFloat(moq.max_quantity) || Infinity;
        
        if (group.totalQuantity >= minQty && group.totalQuantity <= maxQty) {
          applicableMoq = moq;
          break;
        }
      }
    }
    
    // Store the applicable MOQ with the group for later use
    group.applicableMoq = applicableMoq;
    group.productData = productData;
  }
  
  // Track total amounts for the entire quotation
  let quotationSubtotal = 0;
  let quotationTaxTotal = 0;
  let quotationGrandTotal = 0;
  
  // Process each item in the quotation
  updatedQuotation.items = updatedQuotation.items.map(item => {
    if (!item) return item;
    
    // Get base quantity
    const quantity = parseFloat(item.quantity || 0);
    const groupId = item.item_group_id?.toString();
    
    // Get base selling and cost prices
    let baseSellingPrice = 0;
    let baseCostPrice = 0;
    
    // If this item belongs to a group with an applicable MOQ, use the MOQ pricing
    if (groupId && itemsByGroupId[groupId]) {
      const group = itemsByGroupId[groupId];
      
      if (group.applicableMoq) {
        // Use MOQ pricing
        baseSellingPrice = parseFloat(group.applicableMoq.selling_price || 0);
        baseCostPrice = parseFloat(group.applicableMoq.cost_price || 0);
        
        console.log(`Applied MOQ pricing to item in group ${groupId}:`, {
          itemId: item.item_id,
          originalPrice: item.selling_price,
          moqPrice: baseSellingPrice,
          totalGroupQuantity: group.totalQuantity,
          moqMinQty: group.applicableMoq.min_quantity,
          moqMaxQty: group.applicableMoq.max_quantity
        });
      } else if (group.productData) {
        // No applicable MOQ, use product base price
        baseSellingPrice = parseFloat(group.productData.selling_price || item.selling_price || 0);
        baseCostPrice = parseFloat(group.productData.cost_price || item.cost_price || 0);
      } else {
        // Fallback to item's own price
        baseSellingPrice = parseFloat(item.selling_price || 0);
        baseCostPrice = parseFloat(item.cost_price || 0);
      }
    } else {
      // Item doesn't belong to a group, use its own price
      baseSellingPrice = parseFloat(item.selling_price || 0);
      baseCostPrice = parseFloat(item.cost_price || 0);
    }
    
    // Store original base price before addon calculations
    item.base_selling_price = baseSellingPrice;
    
    // Initialize addon totals
    let addonSellingPriceTotal = 0;
    let addonCostPriceTotal = 0;
    let addonTaxTotal = 0;
    
    // Initialize hardware totals separately
    let hardwareSellingPriceTotal = 0;
    let hardwareCostPriceTotal = 0;
    let hardwareTaxTotal = 0;
    
    // Process addons if they exist
    if (item.product_addons && Array.isArray(item.product_addons)) {
      item.product_addons = item.product_addons.map(addon => {
        if (!addon) return addon;
        
        // Get addon quantity (default to main item quantity if not specified)
        const addonQuantity = parseFloat(addon.quantity || quantity);
        
        // Get addon selling price - NO MOQ PROCESSING FOR ADDONS
        const addonSellingPrice = parseFloat(addon.selling_price || 0);
        const addonCostPrice = parseFloat(addon.cost_price || 0);
        
        // Calculate tax for the addon
        const addonTaxRate = parseFloat(addon.tax_rate || 0);
        const addonTax = (addonSellingPrice * addonTaxRate) / 100;
        
        // Update addon with calculated values
        addon.calculated_selling_price = addonSellingPrice;
        addon.calculated_cost_price = addonCostPrice;
        addon.calculated_tax = addonTax;
        addon.total = addonSellingPrice * addonQuantity;
        addon.tax_total = addonTax * addonQuantity;
        
        // Check if this is a hardware addon
        const isHardware = addon?.product_addon_type?.toLowerCase() === 'hardware';
        
        // Add to appropriate totals based on addon type
        if (isHardware) {
          // Add to hardware totals
          hardwareSellingPriceTotal += addon.total;
          hardwareCostPriceTotal += addonCostPrice * addonQuantity;
          hardwareTaxTotal += addon.tax_total;
          
          // Store hardware-specific data for reporting
          addon.is_hardware = true;
        } else {
          // Add to regular addon totals
          addonSellingPriceTotal += addon.total;
          addonCostPriceTotal += addonCostPrice * addonQuantity;
          addonTaxTotal += addon.tax_total;
        }
        
        return addon;
      });
    }
    
    // Calculate tax rate and amount for the main item
    const taxRate = parseFloat(item.tax_rate || 0);
    
    // Calculate per-unit values for regular addons (excluding hardware)
    const addonPricePerUnit = quantity > 0 ? addonSellingPriceTotal / quantity : 0;
    const totalSellingPricePerUnit = baseSellingPrice + addonPricePerUnit;
    
    // Calculate tax on the combined price (base + regular addons)
    const itemTaxPerUnit = (totalSellingPricePerUnit * taxRate) / 100;
    
    // Calculate totals for this item including regular addons (excluding hardware)
    const itemSubtotal = totalSellingPricePerUnit * quantity;
    const itemTaxTotal = itemTaxPerUnit * quantity;
    
    // Add hardware totals separately (not per-unit)
    const totalWithHardware = itemSubtotal + hardwareSellingPriceTotal;
    const taxTotalWithHardware = itemTaxTotal + hardwareTaxTotal;
    const itemTotal = totalWithHardware + taxTotalWithHardware;
    
    // Update item with calculated values
    item.calculated_selling_price = totalSellingPricePerUnit;
    item.selling_price = totalSellingPricePerUnit; // Update selling price to include regular addons
    item.calculated_cost_price = baseCostPrice;
    item.calculated_tax = itemTaxPerUnit;
    item.subtotal = itemSubtotal;
    item.tax_total = itemTaxTotal;
    
    // Store hardware-specific totals
    item.hardware_subtotal = hardwareSellingPriceTotal;
    item.hardware_tax_total = hardwareTaxTotal;
    
    // Store combined totals
    item.total_with_hardware = totalWithHardware;
    item.tax_total_with_hardware = taxTotalWithHardware;
    item.total = itemTotal; // Final total including hardware
    
    // Store addon totals
    item.addon_total = addonSellingPriceTotal;
    item.addon_price_per_unit = addonPricePerUnit;
    
    // Add to quotation totals
    quotationSubtotal += totalWithHardware; // Include hardware in subtotal
    quotationTaxTotal += taxTotalWithHardware; // Include hardware tax
    quotationGrandTotal += itemTotal;
    
    return item;
  });
  
  // Update quotation with calculated totals
  updatedQuotation.subtotal = quotationSubtotal;
  updatedQuotation.tax_total = quotationTaxTotal;
  updatedQuotation.total = quotationGrandTotal;
  
  // Add a summary of hardware costs for reporting
  const hardwareSummary = {
    count: 0,
    subtotal: 0,
    tax_total: 0,
    total: 0
  };
  
  // Calculate hardware summary across all items
  updatedQuotation.items.forEach(item => {
    if (item && item.product_addons && Array.isArray(item.product_addons)) {
      const hardwareAddons = item.product_addons.filter(
        addon => addon && addon.product_addon_type?.toLowerCase() === 'hardware'
      );
      
      hardwareSummary.count += hardwareAddons.length;
      hardwareSummary.subtotal += parseFloat(item.hardware_subtotal || 0);
      hardwareSummary.tax_total += parseFloat(item.hardware_tax_total || 0);
      hardwareSummary.total += parseFloat(item.hardware_subtotal || 0) + parseFloat(item.hardware_tax_total || 0);
    }
  });
  
  // Add hardware summary to quotation
  updatedQuotation.hardware_summary = hardwareSummary;
  
  console.log('Quotation pricing calculated with hardware:', {
    subtotal: quotationSubtotal,
    tax: quotationTaxTotal,
    total: quotationGrandTotal,
    hardwareSummary
  });
  
  return updatedQuotation;
};


  // Helper function to map product addons based on subcategories
  const mapProductAddons = async (addons, doorSubcategories) => {
    if (!addons || !Array.isArray(addons)) return [];
    
    const mappedAddons = [];
    
    for (const addon of addons) {
      const mappedAddon = {
        addon_type: addon.addon_type || "Add-on",
        addon_groups: []
      };
      
      if (addon.addon_groups && Array.isArray(addon.addon_groups)) {
        for (const addonGroup of addon.addon_groups) {
          const mappedGroup = { ...addonGroup };
          
          // Find matching subcategory
          const matchingSubcategory = doorSubcategories && doorSubcategories.find(
            subcategory => subcategory.subcategory && 
                           subcategory.subcategory._id === addonGroup.product_sub_category_id
          );
          
          // If we have a matching subcategory with a default vendor
          if (matchingSubcategory && matchingSubcategory.defaultVendor) {
            const defaultVendorId = matchingSubcategory.defaultVendor._id;
            
            // Filter products by the default vendor
            if (addonGroup.products && Array.isArray(addonGroup.products)) {
              const vendorProducts = addonGroup.products.filter(
                product => product.vendor_id === defaultVendorId
              );
              
              // If we found products for this vendor, use them
              if (vendorProducts.length > 0) {
                // Calculate the selling price for this addon group
                const addonGroupPrice = vendorProducts.reduce(
                  (total, product) => total + (parseFloat(product.selling_price) || 0), 
                  0
                );
                
                mappedGroup.products = vendorProducts;
                mappedGroup.selling_price = addonGroupPrice;
              }
            }
          }
          
          mappedAddon.addon_groups.push(mappedGroup);
        }
      }
      
      // Calculate total addon price
      const addonTotalPrice = mappedAddon.addon_groups.reduce(
        (total, group) => total + (parseFloat(group.selling_price) || 0),
        0
      );
      
      mappedAddon.selling_price = addonTotalPrice;
      mappedAddons.push(mappedAddon);
    }
    
    return mappedAddons;
  };
  
  
 const handleSaveChanges = async () => {
  try {
    setLoading(true);
    
    // Validate quotation data before saving
    if (!quotationData || !quotationData._id) {
      console.error("Invalid quotation data: Missing ID");
      alert("Unable to save changes: Invalid quotation data");
      return;
    }
    
    // Get authentication token
    const token = sessionStorage.getItem('token');
    if (!token) {
      console.error("Authentication token not found");
      alert("Please log in again to continue");
      return;
    }
    
    console.log("Saving customization with data:", {
      quotationId: quotationData._id,
      itemCount: quotationData.items?.length || 0
    });
    
    // Make API request with proper error handling
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/update-quotation-data?quotation_id=${quotationData._id}`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify(quotationData),
      }
    );
    
    // Check for HTTP errors
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Server responded with ${response.status}: ${errorText}`);
    }
    
    // Parse response
    const result = await response.json();
    
    if (result.success) {
      console.log("Customization saved successfully");
      
      // Navigate back with state information
      navigate(-1, { 
        state: { 
          updated: true,
          quotationId: quotationData._id,
          type: type
        } 
      });
    } else {
      // Handle API-level errors
      console.error("Failed to save customization:", result.message);
      alert(`Failed to save: ${result.message || "Unknown error"}`);
    }
  } catch (error) {
    // Handle all other errors
    console.error("Error saving customization:", error);
    alert(`Error saving customization: ${error.message || "An unexpected error occurred"}`);
  } finally {
    setLoading(false);
  }
};



  // Add this function to your component
const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: 0
  }).format(amount || 0);
};

  
  return (
    <div className="min-h-screen bg-gray-100 pb-20">
      <Header />
      
      {/* Sticky header with project name and customization text */}
      <ProjectHeader 
              projectName={data?.project_id?.projectName}
              type={'Customizing Quote'}
              categoryName={data?.customized_by 
                ? data.quotation_number 
                : (data?.package_name || data?.quotation_number)
              }
              buildcoins={
      data?.buildcoins && Array.isArray(data.buildcoins)
        ? data.buildcoins.reduce((sum, item) => sum + (item?.reserved_coins ?? 0), 0)
        : 0
    }        
                      />
      
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-red-500"></div>
        </div>
      ) : (
        <div className="px-4 py-4">
          <BrandCustomizationSection
            doorSubcategories={doorSubcategories}
            preEngDoorSubcategories={preEngDoorSubcategories}
            applicationAreas={applicationAreas}
            doorProducts={doorProducts}
            preEngDoorProducts={preEngDoorProducts}
            doorCores={doorCores}
            onProductSelect={handleProductSelection}
            quotationData={quotationData || data}
            onVendorChange={handleVendorChange}
          />
          
          <div className="">
            <DoorsApplicationAreaMapping
              data={quotationData || data}
              onProductSelect={handleProductSelection}
              onlyDoorProducts={doorProducts}
              preEngDoorProducts={preEngDoorProducts}
              doorSubcategories={doorSubcategories}
              preEngDoorSubcategories={preEngDoorSubcategories}
            />
          </div>
        </div>
      )}
      
     
     {/* Fixed bottom bar with total price and action buttons */}
<div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200">
  {/* Combined price and buttons in a single row */}
  <div className="p-3 flex justify-between items-center max-w-5xl mx-auto">
    {/* Price section */}
    <div className="flex items-baseline flex flex-col space-y-2">
      <span className="text-sm text-gray-500 mr-2">Total Price:</span>
      <div className="flex flex-col items-baseline">
      {quotationData && quotationData.subtotal && (
        <>
        <span className="text-xl font-bold text-[#14A311]">₹{Number(quotationData.subtotal).toLocaleString('en-IN')}</span>
        <span className="text-xs text-gray-500 ml-1">(+ GST & Transport)</span>
        </>
      )}
      
    </div>
     
    </div>
    
    {/* Action buttons */}
    <div className="flex items-center space-x-3">
      <button
        onClick={() => navigate(-1)}
        className="border border-gray-300 text-gray-700 font-medium py-2 px-4 rounded-lg text-sm hover:bg-gray-50 transition-colors"
      >
        Cancel
      </button>
      
      <button
        onClick={handleSaveChanges}
        className="bg-[#C20C0C] text-white font-medium py-2 px-4 rounded-lg text-sm hover:bg-[#A00A0A] transition-colors"
        disabled={loading}
      >
        {loading ? (
          <span className="flex items-center">
            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Saving...
          </span>
        ) : 'Save Changes'}
      </button>
    </div>
  </div>
</div>


   


    </div>
  );
}

export default DoorsCustomize;
